module.exports = __webpack_public_path__ + "static/media/image-768.cca5dbf7.webp";